import React from 'react';
import { useGetUserDetails } from '../../../api-refactored/user/useGetUserDetails';
import { Role } from '../../../models';
import SpecialConsiderationCoordinatorInstructions from '../CoordinatorInstructions';
import SpecialConsiderationInstructions from './SpecialConsiderationInstructions';

const SpecialConsiderationInstructionsPage = () => {
  const { data: userDetails } = useGetUserDetails();

  const isCoordinator = userDetails?.data?.roles?.includes(Role.coordinator);

  return isCoordinator ? (
    <SpecialConsiderationCoordinatorInstructions />
  ) : (
    <SpecialConsiderationInstructions />
  );
};
export default SpecialConsiderationInstructionsPage;
